/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessProject } from '../models/MessProject';
import type { MessProjectCreate } from '../models/MessProjectCreate';
import type { Project } from '../models/Project';
import type { ProjectBase } from '../models/ProjectBase';
import type { ProjectUpdate } from '../models/ProjectUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectsService {
    /**
     * Create Project
     * Create a new project
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createProject(
        requestBody: ProjectBase,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/projects/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Projects
     * List all projects
     * @param skip
     * @param limit
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static listProjects(
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<Array<Project>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/projects/',
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project
     * Get project by ID
     * @param projectId
     * @returns Project Successful Response
     * @throws ApiError
     */
    public static getProject(
        projectId: string,
    ): CancelablePromise<Project> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Project
     * Update project
     * @param projectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateProject(
        projectId: string,
        requestBody: ProjectUpdate,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Project
     * Delete project
     * @param projectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteProject(
        projectId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/projects/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Project Messprojects
     * Get all MessProjects for a specific Project
     *
     * This is a convenience endpoint equivalent to GET /api/messprojects/by-project/{project_id}
     * @param projectId
     * @returns MessProject Successful Response
     * @throws ApiError
     */
    public static getMessprojectsByProject(
        projectId: string,
    ): CancelablePromise<Array<MessProject>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/projects/{project_id}/messprojects',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Messproject For Project
     * Create a new MessProject for a specific Project
     *
     * This is a convenience endpoint that automatically sets the project_id.
     * The project_id is taken from the URL path and doesn't need to be in the request body.
     *
     * Raises:
     * HTTPException 404: If the parent Project does not exist
     * HTTPException 400: If there's a validation error
     * @param projectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createMessprojectForProject(
        projectId: string,
        requestBody: MessProjectCreate,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/projects/{project_id}/messprojects',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
